<template>
    <div v-loading="$parentInfo.loading">
        <div :style="{'position': 'relative','height':clientHeight-170+'px'}">
            <div style="width: 120px;height: 100px;position: absolute;top: 0;left: 0;background: #fff;z-index: 1;">
                <slot name="cachecanvas"></slot>
                <slot name="cachebox"></slot>
            </div>

            <div class="timeCanvas" style="height: calc(100% - 100px)" ref="timeScroll">
                <canvas ref="timecanvas"
                        :width="$parentInfo.timeTable.V4leftTimeW+$parentInfo.timeTable.V4ratio*2"
                        :height="row*$parentInfo.timeTable.V4rectH+$parentInfo.timeTable.V4ratio*2"
                        :style="{'width':($parentInfo.timeTable.V4leftTimeW+$parentInfo.timeTable.V4ratio*2)/$parentInfo.timeTable.V4ratio+'px',
                        'height':(row*$parentInfo.timeTable.V4rectH+$parentInfo.timeTable.V4ratio*2)/$parentInfo.timeTable.V4ratio+'px',
                        'top':(0-$parentInfo.scroll.top+100)+'px'}">
                </canvas>
            </div>

            <div class="teacherCanvas" style="width: calc(100% - 120px)" ref="teacherScroll"
                 @mousemove="handleTeacherMousemove" v-on:mousedown="handleTeacherMousedown">
                <div id="teacherCell"
                     class="scell dragging"
                     v-if="$parentInfo.teacherCell.selectable"
                     :style="{'left':$parentInfo.teacherCell.rect[0]*$parentInfo.timeTable.V4rectW/$parentInfo.timeTable.V4ratio+'px',
                                 'top':$parentInfo.teacherCell.rect[1]*$parentInfo.timeTable.V4titleH/$parentInfo.timeTable.V4ratio+'px',
                                 'height':$parentInfo.timeTable.V4titleH/$parentInfo.timeTable.V4ratio+'px'}"
                     :draggable="$parentInfo.teacherCell.draggable">
                </div>
                <canvas ref="teachercanvas"
                        id="teacher"
                        :width="($parentInfo.tempLength+1)*$parentInfo.timeTable.V4titleW+$parentInfo.timeTable.V4ratio*2"
                        :height="2*$parentInfo.timeTable.V4titleH"
                        :style="{'width':((($parentInfo.tempLength+1)*$parentInfo.timeTable.V4titleW+$parentInfo.timeTable.V4ratio*2))/$parentInfo.timeTable.V4ratio+'px','height':(2*$parentInfo.timeTable.V4titleH)/$parentInfo.timeTable.V4ratio+'px','left':(0-scroll.left+120)+'px'}"></canvas>
                <slot name="teacherBox"></slot>
            </div>

            <div style="width: calc(100% + 5px);height: calc(100% + 5px)" class="tableCanvas" @scroll="handleScroll" ref="viewBox" >
                <div style="position: relative" ref="viewBox" @mousemove="handleMousemove"
                     v-on:mousedown="handleMousedown" @drop='drop($event)'  @dragover='allowDrop($event)'>
                    <div class="mainCanvas">
                        <div id="cell"
                             class="scell dragging"
                             v-if="$parentInfo.cell.selectable"
                             :style="{'left':$parentInfo.cell.rect[0]*$parentInfo.timeTable.V4rectW/$parentInfo.timeTable.V4ratio+'px',
                                      'top':($parentInfo.cell.rect[1]*$parentInfo.timeTable.V4rectH+2)/($parentInfo.timeTable.V4ratio)+'px',
                                      'height':$parentInfo.timeTable.V4rectH/$parentInfo.timeTable.V4ratio-2+'px'}"
                             :draggable="$parentInfo.cell.draggable">

                        </div>
                        <canvas id="timeTable" ref="canvas"
                                :width="($parentInfo.tempLength+1)*$parentInfo.timeTable.V4rectW+$parentInfo.timeTable.V4ratio*2"
                                :height="row*$parentInfo.timeTable.V4rectH"
                                :style="{'width':(($parentInfo.tempLength+1)*$parentInfo.timeTable.V4rectW+$parentInfo.timeTable.V4ratio*2)/$parentInfo.timeTable.V4ratio+'px','height':(row*$parentInfo.timeTable.V4rectH)/$parentInfo.timeTable.V4ratio+'px'}"></canvas>
                        <div class="floatBox dragging"
                             v-if="floatBox.viewJudge"
                             :style="{'left':floatBox.left+'px','top':floatBox.top+'px','width':200+'px',
                            'height':100+'px'}">
                            <TeacherDetail :teacher="floatBox.teacher" v-if="floatBox.type==='teacher'"></TeacherDetail>
                            <StudentDetail :student="floatBox.student" v-if="floatBox.type==='student'"></StudentDetail>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import TeacherDetail from "../V4/widget/TeacherDetail";
    import StudentDetail from "../V4/widget/StudentDetail";

    export default {
        name: 'v4Table',
        data() {
            return {
                borderColor: '#ededed',
                fillStyle: "#555",
                scroll: {
                    x: 0,
                    y: 0
                },

                startPoint: {
                    x: 1,
                    y: 1
                },
                floatBox: {
                    teacher_id: '',
                    student_id: '',
                    type: '',
                    viewJudge: false,
                },
                form: {
                    class_id: '',
                    teacher_id: '',
                    template_time_id: ''
                },
            }
        },
        components: {
            TeacherDetail,
            StudentDetail,
        },
        activated() {
            if (this.scroll.x > 0 || this.scroll.y > 0) {
                this.$refs.teacherScroll.scrollLeft = this.scroll.x ;
                this.$refs.timeScroll.scrollTop = this.scroll.y;
                this.$refs.viewBox.scrollLeft = this.scroll.x ;
                this.$refs.viewBox.scrollTop = this.scroll.y;
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.startPoint = {
                x: this.$parentInfo.timeTable.V4ratio,
                y: this.$parentInfo.timeTable.V4ratio
            };
            this.$nextTick(() => {
                this.initCanvas();
            });
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            list() {
                let length = 0;
                for (let subject_id in this.$parentInfo.subjects) {
                    if(this.$parentInfo.subjects[subject_id].view) {
                        if (this.$parentInfo.teachers[subject_id]) {
                            length += this.$parentInfo.subjects[subject_id].dataLength
                        } else {
                            length += 1;
                        }
                    }
                }
                return length;
            },
            row() {
                let length = 0;
                for (const key in this.$parentInfo.timeData) {
                    length++;
                }
                return length
            }
        },
        mounted(){

        },
        methods: {
            handleTableSite() {
                this.modal = 'table-site';
            },
            //开画
            drawLine(ctx, start = [0, 0], end = [0, 0]) {
                let x = this.startPoint.x;
                let y = this.startPoint.y;
                ctx.moveTo(start[0] + x, start[1] + y);
                ctx.lineTo(end[0] + x, end[1] + y);
            },
            drawRect(ctx, x, y, width, height) {
                ctx.fillRect(x + this.startPoint.x, y + this.startPoint.y, width, height);
            },
            drawText(ctx, text, x, y) {
                ctx.fillText(text, x + this.startPoint.x, y + this.startPoint.y);
            },
            initCanvas() {
                this.clearCanvas();
                this.paintTables();
                this.paintTime();
                this.$parentInfo.loading = false;
            },
            clearCanvas(){
                const teacherCanvas = this.$refs.teachercanvas;
                let ctx = teacherCanvas.getContext('2d');
                ctx.clearRect(0, this.$parentInfo.timeTable.V4titleH, (this.$parentInfo.tempLength+1)*this.$parentInfo.timeTable.V4titleW+this.$parentInfo.timeTable.V4ratio*2,2 * this.$parentInfo.timeTable.V4titleH);

                const canvas = this.$refs.canvas;
                let cctx = canvas.getContext('2d');
                cctx.clearRect(0, 0, (this.$parentInfo.tempLength+1)*this.$parentInfo.timeTable.V4rectW+this.$parentInfo.timeTable.V4ratio*2,
                    this.row * this.$parentInfo.timeTable.V4rectH);
            },
            getFontStyle(size, lineHeight) {
                return 'normal ' + size * this.$parentInfo.timeTable.V4ratio + 'px/' + lineHeight * this.$parentInfo.timeTable.V4ratio + 'px  Microsoft YaHei';
            },
            paintLine() {
                const classCanvas = this.$refs.canvas;
                let ctx = classCanvas.getContext('2d');
                ctx.beginPath();
                //课表竖线
                // for (let i in 100){
                ctx.lineWidth = 2 * this.$parentInfo.timeTable.V4ratio;
                ctx.strokeStyle = "#000";
                this.drawLine(ctx, [0, 0], [0, this.$parentInfo.timeTable.V4rectH * this.row]);
                this.drawLine(ctx, [10, 0], [10, this.$parentInfo.timeTable.V4rectH * this.row]);
                this.drawLine(ctx, [20, 0], [20, this.$parentInfo.timeTable.V4rectH * this.row]);

                this.drawLine(ctx, [0, 0], [1000, 0]);
                this.drawLine(ctx, [0, 10], [1000, 10]);
                this.drawLine(ctx, [0, 20], [1000, 20]);
                // }

                ctx.stroke()
            },
            //画时间
            paintTime() {
                const timecanvas = this.$refs.timecanvas;
                let ctx = timecanvas.getContext('2d');

                ctx.clearRect(0, 0, this.$parentInfo.timeTable.V4leftTimeW, this.row * this.$parentInfo.timeTable.V4rectH);

                ctx.lineWidth = 2 * this.$parentInfo.timeTable.V4ratio;

                ctx.font = this.getFontStyle(12, 12);

                ctx.fillStyle = this.fillStyle;

                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                let i = 0;
                for (const key in this.$parentInfo.timeData) {
                    ctx.fillText(
                        this.$parentInfo.timeData[key].content,
                        this.$parentInfo.timeTable.V4leftTimeW / 2,
                        i * this.$parentInfo.timeTable.V4rectH + this.$parentInfo.timeTable.V4rectH / 2
                    );
                    i++;
                }

                ctx.strokeStyle = this.borderColor;

                //课表竖线
                for (let i = 0; i < 2; i++) {
                    this.drawLine(ctx, [this.$parentInfo.timeTable.V4leftTimeW * i, 0], [this.$parentInfo.timeTable.V4leftTimeW * i, this.$parentInfo.timeTable.V4rectH * this.row]);
                }

                for (let i = 0; i < this.row + 1; i++) {
                    this.drawLine(ctx, [0, this.$parentInfo.timeTable.V4rectH * i], [this.$parentInfo.timeTable.V4leftTimeW, this.$parentInfo.timeTable.V4rectH * i]);
                }
                ctx.stroke()
            },
            //画表
            paintTables() {
                const canvas = this.$refs.canvas;
                let ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, (this.list + 1) * this.$parentInfo.timeTable.V4rectW, this.row * this.$parentInfo.timeTable.V4rectH);
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                for (let key in this.$parentInfo.subjects) {
                    let subject = this.$parentInfo.subjects[key];
                    if(subject.view){
                        this.paintSubjects(subject);
                        let teachers = this._.orderBy(this.$parentInfo.teachers[key], 'sortBy', 'asc');
                        let co = 1;
                        let i = 0;
                        for (const teacher_id in teachers) {
                            let teacher = teachers[teacher_id];
                            if(teacher.view){
                                co++;
                                this.paintClass(teacher, i, subject);
                                this.paintTeachers(teacher, i, subject, co);
                                i++
                            }
                        }
                    }
                }
            },
            //画学科
            paintSubjects(subject) {
                const subjectCanvas = this.$refs.teachercanvas;
                let ctx = subjectCanvas.getContext('2d');
                ctx.globalAlpha = 1;
                ctx.clearRect(subject.rect[0] * this.$parentInfo.timeTable.V4titleW, subject.rect[1] * this.$parentInfo.timeTable.V4titleH, this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH);
                ctx.fillStyle = subject.color;
                this.drawRect(ctx, subject.rect[0] * this.$parentInfo.timeTable.V4titleW, subject.rect[1] * this.$parentInfo.timeTable.V4titleH, subject.rect[2] * this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH);
                ctx.fillStyle = 'rgba(0,0,0,0.5)';
                ctx.font = 'bold ' + 15 * this.$parentInfo.timeTable.V4ratio + 'px/' + 15 * this.$parentInfo.timeTable.V4ratio + 'px  Microsoft YaHei';
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                this.drawText(ctx,
                    subject.name,
                    subject.rect[0] * this.$parentInfo.timeTable.V4titleW + subject.rect[2] * this.$parentInfo.timeTable.V4titleW / 2,
                    subject.rect[1] * this.$parentInfo.timeTable.V4titleH + subject.rect[3] * this.$parentInfo.timeTable.V4titleH / 2
                )

            },
            //画老师
            paintTeachers(teacher, i, subject, co) {
                const teacherCanvas = this.$refs.teachercanvas;
                let ctx = teacherCanvas.getContext('2d');
                ctx.clearRect((subject.rect[0] + i) * this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH, this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH);

                ctx.beginPath();
                ctx.fillStyle = subject.color;
                ctx.globalAlpha = 0.4;
                ctx.fillRect((subject.rect[0] + i) * this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH, this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH);
                ctx.globalAlpha = 1;

                ctx.fillStyle = '#555';
                ctx.font = 'normal ' + 12 * this.$parentInfo.timeTable.V4ratio + 'px/' + 25 * this.$parentInfo.timeTable.V4ratio + 'px  Microsoft YaHei';

                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                //老师名
                this.drawText(ctx,
                    teacher.name,
                    (subject.rect[0] + i) * this.$parentInfo.timeTable.V4titleW + this.$parentInfo.timeTable.V4titleW / 2,
                    this.$parentInfo.timeTable.V4titleH + this.$parentInfo.timeTable.V4titleH / 4);
                //老师备注
                this.drawText(ctx,
                    teacher.note ? teacher.note : '无',
                    (subject.rect[0] + i) * this.$parentInfo.timeTable.V4titleW + this.$parentInfo.timeTable.V4titleW / 2,
                    this.$parentInfo.timeTable.V4titleH + this.$parentInfo.timeTable.V4titleH * 3 / 4);

                if (co != 1) {
                    ctx.lineWidth = 2 * this.$parentInfo.timeTable.V4ratio;
                    ctx.strokeStyle = subject.color;
                    this.drawLine(ctx, [(subject.rect[0] + i) * this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH], [(subject.rect[0] + i) * this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH * 2]);
                    this.drawLine(ctx, [(subject.rect[0] + i + 1) * this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH], [(subject.rect[0] + i + 1) * this.$parentInfo.timeTable.V4titleW, this.$parentInfo.timeTable.V4titleH * 2]);
                }

                ctx.stroke()
            },
            //画班级
            paintClass(teacher, i, subject) {
                let classes = this.$parentInfo.classes[teacher.teacher_id];
                const classCanvas = this.$refs.canvas;
                let ctx = classCanvas.getContext('2d');
                let circle = classCanvas.getContext('2d');

                ctx.beginPath();
                ctx.lineWidth = 2 * this.$parentInfo.timeTable.V4ratio;
                ctx.font = this.getFontStyle(12, 15);
                ctx.fillStyle = '#555';
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";


                let color = '#555';
                for (let class_id in classes) {
                    let classx = classes[class_id];


                    if (Object.keys(classx).length > 1) {
                        this.drawText(ctx, '重复',
                            (subject.rect[0] + i) * this.$parentInfo.timeTable.V4rectW + this.$parentInfo.timeTable.V4rectW / 2,
                            (classx[0].sortBy - 1) * this.$parentInfo.timeTable.V4rectH + this.$parentInfo.timeTable.V4rectH / this.$parentInfo.timeTable.V4divi)
                    } else {
                        if (this.$parentInfo.filter.grade_id.length !== 0) {
                            if (this.$parentInfo.filter.grade_id.includes(classx[0].grade_id)) {
                                ctx.fillStyle = classx[0].color;
                                color = classx[0].color;
                            } else {
                                ctx.fillStyle = '#ededed';
                                color = '#ededed';
                            }
                        } else {
                            if (![3, 6].includes(classx[0].class_type_id)) {
                                ctx.fillStyle = '#FF0000';
                                color = '#FF0000';
                            } else {
                                ctx.fillStyle = classx[0].color;
                                color = classx[0].color;
                            }
                        }

                        if (this.$parentInfo.filter.semester_id != classx[0].semester_id) {
                            ctx.fillStyle = '#ededed';
                            color = '#ededed';
                        }

                        let height=1;
                        if(classx[0].duration>this.$parentInfo.timeData[classx[0].sortBy].duration){
                            if(this.$parentInfo.timeData[classx[0].sortBy+1]){
                                if(this.$parentInfo.timeData[classx[0].sortBy+1].template_day_semester_id===this.$parentInfo.timeData[classx[0].sortBy].template_day_semester_id){
                                    height=1+(classx[0].duration-this.$parentInfo.timeData[classx[0].sortBy].duration)/this.$parentInfo.timeData[classx[0].sortBy+1].duration
                                }
                            }
                        }

                        ctx.globalAlpha = 0.05;
                        ctx.fillRect((subject.rect[0] + i) * this.$parentInfo.timeTable.V4rectW, (classx[0].sortBy - 1) * this.$parentInfo.timeTable.V4rectH,
                            this.$parentInfo.timeTable.V4rectW, this.$parentInfo.timeTable.V4rectH*height);
                        ctx.globalAlpha = 1;

                        for (let d = 0; d < 1; d++) {
                            //班级名
                            this.drawText(ctx, classx[0].class.slice(d * 8, 8 + d * 9),
                                (subject.rect[0] + i) * this.$parentInfo.timeTable.V4rectW + this.$parentInfo.timeTable.V4rectW / 2,
                                (classx[0].sortBy - 1) * this.$parentInfo.timeTable.V4rectH + this.$parentInfo.timeTable.V4rectH / this.$parentInfo.timeTable.V4divi * ((d ? 3 : 1) / 2));

                            if (d === 1)
                                break;

                            var secondName = classx[0].classroom_name ? classx[0].classroom_name.slice(4, 20) : '无'
                            if (this.$parentInfo.filter.semester_id != classx[0].semester_id) {
                                secondName = classx[0].section_name
                            }

                            //教室名
                            this.drawText(ctx, secondName,
                                (subject.rect[0] + i) * this.$parentInfo.timeTable.V4rectW + this.$parentInfo.timeTable.V4rectW / 2,
                                (classx[0].sortBy - 1) * this.$parentInfo.timeTable.V4rectH + this.$parentInfo.timeTable.V4rectH / this.$parentInfo.timeTable.V4divi * ((d ? 3 : 1) / 2) + 20 * window.devicePixelRatio)
                        }
                        //班级学生姓名
                        if (this.$parentInfo.class_student[classx[0].class_id]) {
                            if (this.$parentInfo.showStudent && this.$parentInfo.class_student[classx[0].class_id].length > 0) {
                                let row = 5;
                                let a = 0;
                                let b = 2;
                                for (let student of this.$parentInfo.class_student[classx[0].class_id]) {
                                    let drawStudent = true;
                                    if (this.$parentInfo.type === 'dayTimeTable') {
                                        if (student.classPlan_id !== classx[0].class_plan_id) {
                                            drawStudent = false;
                                        }
                                        if (student.status === 'active') {
                                            color = 'grey';
                                        } else if (student.status === 'cancel') {
                                            color = "#898989";
                                        } else if (student.status === 'leaving') {
                                            color = 'rgba(133,214,225,1)';
                                        } else if (student.status === 'absent') {
                                            color = "#946767";
                                        } else if (student.status === 'switching') {
                                            color = "#81AEE4";
                                        } else if (student.status === 'refund') {
                                            color = "#F5A77C";
                                        } else if (student.status === 'finished') {
                                            color = "#D2EAB9";
                                        } else if (student.status === 'truancy') {
                                            color = "#E77E7E";
                                        } else if (student.status === 'trying') {
                                            color = "rgba(204,204,0,1)";
                                        }
                                    }
                                    ctx.fillStyle = color;

                                    if (drawStudent) {
                                        ctx.fillText(student.student_name,
                                            (subject.rect[0] + i) * this.$parentInfo.timeTable.V4rectW + this.$parentInfo.timeTable.V4rectW / this.$parentInfo.timeTable.V4divi * (row % 2 === 0 ? 6 : 2),
                                            (classx[0].sortBy - 1) * this.$parentInfo.timeTable.V4rectH + this.$parentInfo.timeTable.V4rectH / this.$parentInfo.timeTable.V4divi / 2 * (row % 2 === 0 ? row - 1 : row));

                                        if (this.$parentInfo.powers.includes(112) && this.$parentInfo.type === 'timeTable' && this.$parentInfo.crunkView) {
                                            circle.beginPath();
                                            circle.arc(
                                                (subject.rect[0] + i) * this.$parentInfo.timeTable.V4rectW + this.$parentInfo.timeTable.V4rectW / this.$parentInfo.timeTable.V4divi * (row % 2 === 0 ? 6 : 2) + 10 * window.devicePixelRatio,
                                                ((classx[0].sortBy - 1) * this.$parentInfo.timeTable.V4rectH + this.$parentInfo.timeTable.V4rectH / this.$parentInfo.timeTable.V4divi / 2 * (row % 2 === 0 ? row - 1 : row) - 10 * window.devicePixelRatio),
                                                7 * window.devicePixelRatio,
                                                0, 360);
                                            circle.strokeStyle = 'rgba(255, 255, 255, 0)';
                                            circle.fillStyle = "rgba(255, 255, 255, 0)";
                                            circle.fill();
                                            circle.fillStyle = "#000";
                                            circle.font = 'normal ' + 11 * this.$parentInfo.timeTable.V4ratio + 'px/' + 14 * this.$parentInfo.timeTable.V4ratio + 'px  Microsoft YaHei'
                                            if (student.hasClass === null) {
                                                student.hasClass = 0;
                                            }
                                            circle.fillText(student.hasClass,
                                                (subject.rect[0] + i) * this.$parentInfo.timeTable.V4rectW + 10 + this.$parentInfo.timeTable.V4rectW / this.$parentInfo.timeTable.V4divi * (row % 2 === 0 ? 6 : 2) + 10 * window.devicePixelRatio,
                                                (classx[0].sortBy - 1) * this.$parentInfo.timeTable.V4rectH + this.$parentInfo.timeTable.V4rectH / this.$parentInfo.timeTable.V4divi / 2 * (row % 2 === 0 ? row - 1 : row) - 10 * window.devicePixelRatio);
                                            circle.stroke();
                                            circle.closePath();
                                        }

                                        student.rect = [a, b, 1, 1];
                                        a++;
                                        if (a > 1) {
                                            b++;
                                            a = 0;
                                        }
                                        row++
                                    }
                                }
                            }
                        }
                    }
                }
                ctx.stroke();

                ctx.beginPath();
                ctx.lineWidth = 2 * this.$parentInfo.timeTable.V4ratio;
                ctx.strokeStyle = subject.color;

                //课表竖线
                for (let i = 0; i < subject.rect[2] + 1; i++) {
                    this.drawLine(ctx, [this.$parentInfo.timeTable.V4rectW * (i + subject.rect[0]), 0], [this.$parentInfo.timeTable.V4rectW * (i + subject.rect[0]), this.$parentInfo.timeTable.V4rectH * this.row]);
                }

                //课表横线
                for (let i = 0; i < this.row + 1; i++) {
                    this.drawLine(ctx, [subject.rect[0] * this.$parentInfo.timeTable.V4titleW, i * this.$parentInfo.timeTable.V4rectH], [subject.rect[0] * this.$parentInfo.timeTable.V4titleW + subject.rect[2] * this.$parentInfo.timeTable.V4titleW, i * this.$parentInfo.timeTable.V4rectH]);
                }
                ctx.stroke()
            },
            //滚轮滚动
            handleScroll(e) {
                this.$parentInfo.cell.selectable=false;
                this.$refs.teacherScroll.scrollLeft = e.target.scrollLeft;
                this.$refs.timeScroll.scrollTop = e.target.scrollTop;
                this.scroll.x= e.target.scrollLeft;
                this.scroll.y= e.target.scrollTop;
                this.$emit('cartScroll', e.target.scrollTop)
            },
            getPara(inx, iny) {
                const x = inx * this.$parentInfo.timeTable.V4ratio;
                const y = iny * this.$parentInfo.timeTable.V4ratio;
                const px = Math.floor(x / this.$parentInfo.timeTable.V4rectW);
                const py = Math.floor(y / this.$parentInfo.timeTable.V4rectH);

                //寻找subject_id
                let subject_id = 0;
                for (let key in this.$parentInfo.subjects) {
                    if(this.$parentInfo.subjects[key].view){
                        if (this.$parentInfo.subjects[key].rect[0] * this.$parentInfo.timeTable.V4rectW < x && x < (this.$parentInfo.subjects[key].rect[2] + this.$parentInfo.subjects[key].rect[0]) * this.$parentInfo.timeTable.V4rectW) {
                            subject_id = key;
                            break;
                        }
                    }

                }

                //寻找老师id
                let teacher_id = 0;
                let subject = this.$parentInfo.subjects[subject_id];
                let teachers = this._.orderBy(this.$parentInfo.teachers[subject_id], 'sortBy', 'asc');

                let j = 0;
                let nx = 0;
                for (const key in teachers) {
                    if(teachers[key].view) {
                        if ((subject.rect[0] + j) * this.$parentInfo.timeTable.V4rectW < x && x < (subject.rect[0] + j + 1) * this.$parentInfo.timeTable.V4rectW) {
                            nx = subject.rect[0] + j;
                            teacher_id = teachers[key].teacher_id;
                            break;
                        }
                        j++;
                    }
                }

                //获取时间

                let template_time_id = this.$parentInfo.timeData[Object.keys(this.$parentInfo.timeData)[py]].id;
                let template_time_semester_id = this.$parentInfo.timeData[Object.keys(this.$parentInfo.timeData)[py]].template_time_semester_id;

                return {
                    subject_id: subject_id,
                    teacher_id: teacher_id,
                    template_time_id: template_time_id,
                    template_time_semester_id: template_time_semester_id,
                    rect: [nx, py, 1, 1],
                }
            },
            //点击教师标题
            handleTeacherMousemove(evt) {
                this.floatBox.type = '';
                const x = evt.offsetX * this.ratio;
                const y = (evt.offsetY) * this.ratio;

                let floatBox = {
                    teacher_id: '',
                    student_id: '',
                    type: '',
                    left: 0,
                    top: 0,
                    viewJudge: false,
                };

                let subject_id = 0;
                for (let key in this.$parentInfo.subjects) {
                    if(this.$parentInfo.subjects[key].view){
                        if (this.$parentInfo.subjects[key].rect[0] * this.rectW < x && x < (this.$parentInfo.subjects[key].rect[2] + this.$parentInfo.subjects[key].rect[0]) * this.rectW) {
                            subject_id = key;
                            break;
                        }
                    }

                }
                let subject = this.$parentInfo.subjects[subject_id];

                let teachers = this._.orderBy(this.$parentInfo.teachers[subject_id], 'sortBy', 'asc');
                let j = 0;
                for (const key in teachers) {
                    if(teachers[key].view){
                        if ((subject.rect[0] + j) * this.rectW < x && x < (subject.rect[0] + j + 1) * this.rectW) {
                            floatBox.teacher_id = teachers[key].teacher_id;
                            floatBox.left = (subject.rect[0] + j) * this.titleW;
                            break;
                        }
                        j++;
                    }
                }
                let scrollY = Math.floor((y - this.scrollTop) / this.titleH);
                //老师详情
                if (scrollY === 1 && x > 10) {
                    floatBox.type = 'teacher';
                    floatBox.left = floatBox.left + this.titleW / 2;
                    floatBox.top = this.$refs.timeScroll.scrollTop - this.titleH / 4;
                }
                this.delayTime(floatBox);
            },
            handleTeacherMousedown(evt) {
                // this.$parent.handleTeacherMouseDown(evt);
                this.$parentInfo.cell.selectable = false;
                if (evt.target.id === 'teacherCell') {
                    this.$parentInfo.teacherCell.clickTable = true;
                    return this.$emit('handleTeacherMouseDown');
                } else if (evt.target.id === 'teacher') {
                    let {subject_id, teacher_id, template_time_id, template_time_semester_id, rect} = this.getPara(evt.offsetX, evt.offsetY);
                    this.$parentInfo.teacherCell = {
                        rect: rect,
                        subject_id: subject_id,
                        teacher_id: teacher_id,
                        template_time_id: template_time_id,
                        template_time_semester_id: template_time_semester_id,
                        draggable: false,
                        selectable: true
                    };
                }
            },
            handleMousemove(evt) {
                const x = evt.offsetX * this.ratio;
                const y = (evt.offsetY) * this.ratio;
                const py = Math.floor(y / this.$parentInfo.rectH);
                const px = Math.floor(x / this.rectW);
                let floatBox = {
                    teacher_id: '',
                    student_id: '',
                    type: '',
                    left: 0,
                    top: 0,
                    viewJudge: false,
                };
                let subject_id = 0;
                for (let key in this.$parentInfo.subjects) {
                    if(this.$parentInfo.subjects[key].view) {
                        if (this.$parentInfo.subjects[key].rect[0] * this.rectW < x && x < (this.$parentInfo.subjects[key].rect[2] + this.$parentInfo.subjects[key].rect[0]) * this.rectW) {
                            subject_id = key;
                            break;
                        }
                    }
                }
                let subject = this.$parentInfo.subjects[subject_id];
                let teachers = this._.orderBy(this.$parentInfo.teachers[subject_id], 'sortBy', 'asc');
                let j = 0;
                for (const key in teachers) {
                    if(teachers[key].view) {
                        if ((subject.rect[0] + j) * this.rectW < x && x < (subject.rect[0] + j + 1) * this.rectW) {
                            floatBox.teacher_id = teachers[key].teacher_id;
                            floatBox.left = (subject.rect[0] + j) * this.titleW;
                            break;
                        }
                        j++;
                    }
                }
                let scrollY = Math.floor((y - this.scrollTop) / this.titleH);
                //学生详情
                if (scrollY >= 0 && x > 10) {
                    if (this.$parentInfo.rectH !== 200 * window.devicePixelRatio) {
                        this.floatBox.viewJudge = false;
                        return 0;
                    }
                    if (!floatBox.teacher_id)
                        return 0;
                    floatBox.template_time_id = this.$parentInfo.timeData[py + 1].id;
                    if (this.$parentInfo.classes[floatBox.teacher_id] &&
                        this.$parentInfo.classes[floatBox.teacher_id][floatBox.template_time_id] &&
                        this.$parentInfo.classes[floatBox.teacher_id][floatBox.template_time_id].length === 1) {
                        let classx = this.$parentInfo.classes[floatBox.teacher_id][floatBox.template_time_id][0];
                        let sx = evt.offsetX * this.ratio - floatBox.left;
                        let sy = y - (classx.sortBy - 1) * this.$parentInfo.rectH;

                        let psx = (Math.floor(sx / 50) / 2 === 0) ? 0 : 1;
                        let psy = Math.floor(sy / (this.$parentInfo.rectH / this.ratio / this.$parentInfo.divi));

                        let t = 0;
                        if (psx === 0) {
                            t = (psy - 2) * 2
                        } else {
                            t = (psy - 2) * 2 + 1
                        }
                        this.studentCell = {
                            rect: [psx, psy, 1, 1]
                        };
                        let rect = [psx, psy, 1, 1];
                        for (const student_id in this.$parentInfo.class_student[classx.class_id]) {
                            let student_rect = this.$parentInfo.class_student[classx.class_id][student_id].rect;
                            if (rect.sort().toString() === student_rect.sort().toString()) {
                                let student = this.$parentInfo.class_student[classx.class_id][student_id];
                                floatBox.left = floatBox.left + (student_rect[0] % 2 === 0 ? (1 / 2) : (1)) * this.rectW;
                                floatBox.top = y;
                                floatBox.type = 'student';
                                floatBox.student_id = student.student_id;
                            }
                        }
                    }
                }
                this.delayTime(floatBox)
            },
            delayTime(floatBox) {
                if (floatBox.type === 'teacher') {
                    if (floatBox.teacher_id !== this.floatBox.teacher_id && floatBox.teacher_id !== '') {
                        this.floatBox = floatBox;
                        this.$wApi.send(this.$parentInfo.path, 'floatBox', {
                            'teacher_id': floatBox.teacher_id,
                            'semester_id': this.$parentInfo.semester_id,
                            'type': 'teacher',
                        });
                    }
                } else if (floatBox.type === 'student') {
                    if (floatBox.student_id !== this.floatBox.student_id && floatBox.student_id !== '') {
                        this.floatBox = floatBox;
                        this.$wApi.send(this.$parentInfo.path, 'floatBox', {
                            'student_id': floatBox.student_id,
                            'semester_id': this.$parentInfo.semester_id,
                            'type': 'student',
                        });
                    }
                } else {
                    this.floatBox.teacher_id = '';
                    this.floatBox.student_id = '';
                    this.floatBox.viewJudge = false;
                }
            },
            sleep(numberMillis) {
                let now = new Date();
                let exitTime = now.getTime() + numberMillis;
                while (true) {
                    now = new Date();
                    if (now.getTime() > exitTime)
                        return;
                }
            },
            handleMousedown(evt) {
                if (evt.button===1){
                    this.$parentInfo.cell.selectable=false;
                    return;
                }
                this.$parentInfo.teacherCell.selectable = false;
                if (evt.target.id === 'timeTable') {
                    let {subject_id, teacher_id, template_time_id, template_time_semester_id, rect} = this.getPara(evt.offsetX, evt.offsetY);
                    this.$parentInfo.cell = {
                        rect: rect,
                        subject_id: subject_id,
                        teacher_id: teacher_id,
                        template_time_id: template_time_id,
                        template_time_semester_id: template_time_semester_id,
                        selectable: true,
                        draggable: true,
                    };
                } else if (evt.target.id === 'cell') {
                    let data = {
                        'type': 'blank',
                        'subject_id': this.$parentInfo.cell.subject_id,
                        'teacher_id': this.$parentInfo.cell.teacher_id,
                        'template_time_id': this.$parentInfo.cell.template_time_id,
                        'template_time_semester_id': this.$parentInfo.cell.template_time_semester_id,
                    };
                    if (this.$parentInfo.classes[this.$parentInfo.cell.teacher_id] && this.$parentInfo.classes[this.$parentInfo.cell.teacher_id][this.$parentInfo.cell.template_time_id]) {
                        if (this.$parentInfo.classes[this.$parentInfo.cell.teacher_id][this.$parentInfo.cell.template_time_id].length === 1) {
                            let classx = this.$parentInfo.classes[this.$parentInfo.cell.teacher_id][this.$parentInfo.cell.template_time_id][0];
                            data.type = 'class';
                            this.$parentInfo.cell.name = classx.class;
                            this.$parentInfo.cell.color = classx.color;
                            if (this.$parentInfo.type == 'semesterTable') {
                                this.$parentInfo.cell.draggable = true;
                            }
                        } else {
                            data.type = 'classes';
                        }
                    }
                    this.$parentInfo.cell.clickTable = true;

                    return this.$emit('handleMouseDown', {
                        'x': evt.offsetX * this.$parentInfo.timeTable.V4ratio,
                        'y': evt.offsetY * this.$parentInfo.timeTable.V4ratio,
                        'data': data,
                    });
                }
            },
            //拖动
            drop(evt) {
                evt.preventDefault();
                let {subject_id, teacher_id, template_time_id, template_time_semester_id, rect} = this.getPara(evt.offsetX, evt.offsetY);
                let data = {
                    'type': 'blank',
                    'subject_id': subject_id,
                    'teacher_id': teacher_id,
                    'template_time_id': template_time_id,
                    'template_time_semester_id': template_time_semester_id,
                };
                return this.$emit('drop', {
                    'origin': this.$parentInfo.cell,
                    'next': data,
                });
            },
            //允许拖动
            allowDrop: function (event) {
                return this.$emit('allowDrop', event);
            },
        },
        beforeDestroy() {

        }
    }
</script>
<style scoped lang="scss">
    $border-color: #ededed;
    .canvas-border {
        border: 2px solid $border-color;
    }

    .timeCanvas {
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }

        canvas {
            background: #fff;
        }

        z-index: 1;
        background: #fff;
        position: absolute;
        top: 100px;
        overflow: auto;

        .item {
            &:last-of-type {
                border-bottom: 1px solid #555;
            }

            height: 50px;
            border-top: 1px solid #555;
            border-left: 1px solid #555;
            border-right: 1px solid #555;
            text-align: center;
            box-sizing: border-box;
        }
    }

    .teacherCanvas {
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }
        canvas {
            background: #fff;
        }
        z-index: 1;
        position: absolute;
        left: 120px;
        top: 0px;
        overflow: auto;
    }

    .tableCanvas {
        &::-webkit-scrollbar {
            width:  5px;
            height: 5px;
        }
        overflow: scroll;
    }

    .mainCanvas {
        display: inline-block;
        position: absolute;
        left: 120px;
        top: 100px;
    }

    .subjectcontent {
        position: relative;
        float: left;
        margin: 0 2px;
    }

    .floatBox {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        z-index: 1200;
    }

    .scell {
        z-index: 2;
        display: table;
        cursor: pointer !important;
        position: absolute;
        background: transparent;
        color: #555;
        width: 102px;
        border: 2px solid rgb(141, 193, 245);
        border-radius: 2px;
    }

    .scell span {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        font-size: 12px;
        line-height: 15px;
        font-weight: 400;
        font-family: 'Microsoft Yahei UI';
    }

    .studentCell {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        z-index: 1200;
        width: 44px;
        height: 20px;
        border: 2px solid rgb(141, 193, 245);
        border-radius: 2px;
    }
</style>
